import { render, staticRenderFns } from "./LiberarArquivos.html?vue&type=template&id=34bca916&scoped=true&"
import script from "./LiberarArquivos.vue?vue&type=script&lang=js&"
export * from "./LiberarArquivos.vue?vue&type=script&lang=js&"
import style0 from "./LiberarArquivos.css?vue&type=style&index=0&id=34bca916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bca916",
  null
  
)

export default component.exports